// @flow

import React from 'react';
import download from './download.gif';

export const Download = () => <img src={download} alt="download-app" />;

export default Download;
